import React, { FC } from 'react'
import { TypeNewForm, TypeNewFormProps } from '../common/newType'

type ProjectNewTypeFormProps = Omit<TypeNewFormProps, 'placeholder'>

export const ProjectTypeNewForm: FC<ProjectNewTypeFormProps> = (props) => {
  return <TypeNewForm {...props} placeholder="New Project Type Name" />
}
